import {
    AccountsReceivableLedgerTypeEnum
} from '../../../../dave-data-module/entities/accounts-receivable-ledger.entity';

export const depthFromPosition = (position: string | null | undefined) => {
    return position ? position.split('.').length - 2 : 0
}


/**
 *
 * @param FlEk ek aus formcontrol
 * @param arlCalculationPreChargeByType InfoiceFormGroup.controls.ARLCalculationPreChargeByTypes – 10% = 0.1
 */
export function getExternalServiceEkWithPreCharge(FlEk: number, arlCalculationPreChargeByType: number) {
    return (FlEk || 0) * (1 + (arlCalculationPreChargeByType || 0));
}
export function getSalaryEkWithPreCharge(salaryEk: number, arlCalculationPreChargeByType: number) {
    return getExternalServiceEkWithPreCharge(salaryEk, arlCalculationPreChargeByType);
}
export function getResourceEkWithPreCharge(GEK: number, arlCalculationPreChargeByType: number, preventGlobalPreCharge: boolean) {
    return getExternalServiceEkWithPreCharge(GEK, preventGlobalPreCharge ? 0 : arlCalculationPreChargeByType);
}

export function getOtherEkWithPreCharge(SoEk: number, SoEkRabatt: number, SoAntEk: number, arlCalculationPreChargeByType: number) {
    return getExternalServiceEkWithPreCharge(getOtherEk(SoEk, SoEkRabatt, SoAntEk), arlCalculationPreChargeByType);
}
export function getOtherEk(SoEk: number, SoEkRabatt: number, SoAntEk: number) {
    return ((SoEk || 0) * (1 - (SoEkRabatt || 0) / 100) + SoAntEk || 0);
}

export const getSalaryEk = (PartieHEur: number | undefined, minutes: number | undefined) => {
    return ((PartieHEur || 0) * (minutes || 0)) / 60;
}



/**
 *
 * @param externalServiceEkWithPreCharge
 * @param chargeByType from arlGlobalSurcharge with correct type
 */
export function getExternalServiceWithPreChargeAndCharge(externalServiceEkWithPreCharge: number, chargeByType: number) {
    return externalServiceEkWithPreCharge * (1 + chargeByType / 100)
}
export function getResourceWithPreChargeAndCharge(resourceEkWithPreCharge: number, chargeByType: number) {
    return getExternalServiceWithPreChargeAndCharge(resourceEkWithPreCharge, chargeByType);
}
export function getOtherWithPreChargeAndCharge(otherEkWithPreCharge: number, chargeByType: number) {
    return getExternalServiceWithPreChargeAndCharge(otherEkWithPreCharge, chargeByType);
}
export function getSalaryWithPreChargeAndCharge(salaryEkWithPreCharge: number, chargeByType: number) {
    return getExternalServiceWithPreChargeAndCharge(salaryEkWithPreCharge, chargeByType);
}

/**
 *
 * @param externalServiceWithPreChargeAndCharge
 * @param globalPreCharge ZS aus erhöhung minderung
 * @param preventPreCharge
 */
export function getExternalServiceVK(externalServiceWithPreChargeAndCharge: number, globalPreCharge: number, preventPreCharge: boolean): number {
    return preventPreCharge ? externalServiceWithPreChargeAndCharge : externalServiceWithPreChargeAndCharge * (1 + (globalPreCharge || 0));
}
export function getResourceVK(resourceWithPreChargeAndCharge: number, globalPreCharge: number, preventPreCharge: boolean ) {
    return getExternalServiceVK(resourceWithPreChargeAndCharge, globalPreCharge, preventPreCharge);
}
export function getOtherVK(otherWithPreChargeAndCharge: number, globalPreCharge: number, preventPreCharge: boolean ) {
    return getExternalServiceVK(otherWithPreChargeAndCharge, globalPreCharge, preventPreCharge);
}
export function getSalaryVK(salaryWithPreChargeAndCharge: number, globalPreCharge: number, preventPreCharge: boolean ) {
    return getExternalServiceVK(salaryWithPreChargeAndCharge, globalPreCharge, preventPreCharge);
}

/**
 *
 * @param positionValues
 * @param globalPreCharge
 * @param preventGlobalPreCharge
 * @param arlCalculationPreChargeByTypes InfoiceFormGroup.controls.ARLCalculationPreChargeByTypes
 * @param ledgerImportChargesByType InfoiceFormGroup.controls.ARLSurChargeByTypes
 */
export function getAllVK(
    positionValues: {
        FlEk: number,
        GEK: number,
        SoEk: number,
        SoEkRabatt: number,
        SoAntEk: number,
        PartieHEur: number,
        minutes: number,
    },
    globalPreCharge: number,
    preventGlobalPreCharge: boolean,
    arlCalculationPreChargeByTypes: Map<AccountsReceivableLedgerTypeEnum, number>,
    arlSurChargeByTypes: Map<AccountsReceivableLedgerTypeEnum, number>,
) {



    return {
        FlVk: getExternalServiceVK(
            getExternalServiceWithPreChargeAndCharge(
                getExternalServiceEkWithPreCharge(positionValues.FlEk, arlCalculationPreChargeByTypes.get(AccountsReceivableLedgerTypeEnum.ExternalService) || 0),
                arlSurChargeByTypes.get(AccountsReceivableLedgerTypeEnum.ExternalService) || 0,
            ),
            globalPreCharge,
            preventGlobalPreCharge
        ),
        GVK: getResourceVK(
            getResourceWithPreChargeAndCharge(
                getResourceEkWithPreCharge(positionValues.GEK, arlCalculationPreChargeByTypes.get(AccountsReceivableLedgerTypeEnum.ResourceArl) || 0, preventGlobalPreCharge),
                arlSurChargeByTypes.get(AccountsReceivableLedgerTypeEnum.ResourceArl) || 0,
            ),
            globalPreCharge,
            preventGlobalPreCharge
        ),
        SoVk: getOtherVK(
            getOtherWithPreChargeAndCharge(
                getOtherEkWithPreCharge(positionValues.SoEk, positionValues.SoEkRabatt, positionValues.SoAntEk, arlCalculationPreChargeByTypes.get(AccountsReceivableLedgerTypeEnum.MaterialArl) || 0),
                arlSurChargeByTypes.get(AccountsReceivableLedgerTypeEnum.MaterialArl) || 0,
            ),
            globalPreCharge,
            preventGlobalPreCharge
        ),
        SalaryVk: getSalaryVK(
            getSalaryWithPreChargeAndCharge(
                getSalaryEkWithPreCharge(getSalaryEk(positionValues.PartieHEur, positionValues.minutes), arlCalculationPreChargeByTypes.get(AccountsReceivableLedgerTypeEnum.EmployeeArl) || 0),
                arlSurChargeByTypes.get(AccountsReceivableLedgerTypeEnum.EmployeeArl) || 0,
            ),
            globalPreCharge,
            preventGlobalPreCharge
        )
    }

}
